<div class="page" dir="rtl">
  <header class="hero">
    <p class="eyebrow">ניהול קטלוג</p>
    <h1>סיווג מוצרים</h1>
    <p class="lede">
      שני תורים: מה שצריך אישור שלכם, ומה שנשמר אוטומטית. לחיצה על מוצר פותחת את כרטיס המוצר.
      רק אימות ידני נחשב אימות שלכם. מודל נשמר עם מזהה המודל והעלות.
    </p>
    <div class="tabs" role="tablist">
      <button
        type="button"
        role="tab"
        [class.active]="view === 'needs'"
        data-testid="classification-tab-needs"
        (click)="switchView('needs')"
      >
        צריך אותי
      </button>
      <button
        type="button"
        role="tab"
        [class.active]="view === 'autosaved'"
        data-testid="classification-tab-autosaved"
        (click)="switchView('autosaved')"
      >
        נשמר אוטומטית
      </button>
    </div>
  </header>

  <form class="lookup" (submit)="$event.preventDefault(); previewLookup()">
    <label for="classification-barcode">ברקוד</label>
    <div class="lookup-row">
      <input
        id="classification-barcode"
        class="barcode-input"
        data-testid="classification-barcode"
        name="barcode"
        type="text"
        inputmode="numeric"
        [(ngModel)]="barcode"
        placeholder="7290000000000"
      />
      <button type="submit" data-testid="classification-preview" [disabled]="loading">
        הצע סיווג
      </button>
      <button
        type="button"
        class="secondary"
        data-testid="classification-random"
        (click)="loadRandomProduct()"
        [disabled]="loading"
      >
        מוצר אקראי
      </button>
    </div>
  </form>

  <section class="card" *ngIf="view === 'needs'" aria-label="תור לאישור">
    <h2>צריך אותי</h2>
    <p class="muted" *ngIf="proposals.length === 0">אין הצעות ממתינות. הריצו סיווג מודל על מוצר.</p>
    <ul class="queue" *ngIf="proposals.length">
      <li *ngFor="let item of proposals" class="proposal" [class.open]="isProposalOpen(item)">
        <div class="proposal-head">
          <button
            type="button"
            class="proposal-toggle"
            [attr.aria-expanded]="isProposalOpen(item)"
            (click)="openProposal(item)"
          >
            <span class="proposal-kind">{{ proposalKindLabel(item.kind) }}</span>
            <span class="proposal-copy">
              <span class="proposal-title">{{ item.nameHe }}</span>
              <span class="proposal-slug" dir="ltr">{{ item.suggestedSlug }}{{ item.parentSlug ? ' · ' + item.parentSlug : '' }}</span>
            </span>
            <span class="proposal-count">{{ item.productCount }} מוצרים</span>
            <span class="proposal-chevron" aria-hidden="true"></span>
          </button>
          <div class="proposal-actions">
            <button type="button" class="proposal-accept" (click)="acceptProposal(item, $event)">הוסף</button>
            <button type="button" class="proposal-reject" (click)="rejectProposal(item, $event)">דחה</button>
          </div>
        </div>
        <div class="proposal-body" *ngIf="isProposalOpen(item)">
          <p class="muted proposal-status" *ngIf="proposalProductsLoading">טוען מוצרים…</p>
          <p class="muted proposal-status" *ngIf="!proposalProductsLoading && proposalProducts.length === 0">
            אין מוצרים בהצעה.
          </p>
          <ul class="proposal-products" *ngIf="!proposalProductsLoading && proposalProducts.length">
            <li *ngFor="let row of proposalProducts">
              <button type="button" class="product-chip" (click)="openListedProduct(row.barcode)">
                <span class="product-chip-name" dir="auto">{{ row.displayName }}</span>
                <span class="product-chip-barcode" dir="ltr">{{ row.barcode || '—' }}</span>
              </button>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </section>

  <section class="card" *ngIf="view === 'autosaved'" aria-label="נשמר אוטומטית">
    <h2>נשמר אוטומטית</h2>
    <div class="lookup-row">
      <input type="text" [(ngModel)]="autosavedModel" placeholder="סינון לפי מודל, למשל gemini-2.5-pro" />
      <button type="button" class="secondary" (click)="loadAutosaved()">סנן</button>
    </div>
    <p class="muted" *ngIf="autosaved.length === 0">אין שמירות אוטומטיות עדיין.</p>
    <button
      type="button"
      class="queue-row"
      *ngFor="let row of autosaved"
      (click)="openListedProduct(row.barcode)"
    >
      {{ row.displayName }} · {{ row.model }} · {{ row.graphVersion }}
    </button>
  </section>

  <p class="error" role="alert" *ngIf="errorMessage">{{ errorMessage }}</p>
  <p class="ok" *ngIf="statusMessage">{{ statusMessage }}</p>
  <p class="muted" *ngIf="loading">מריץ שיטות סיווג מהירות…</p>

  <ng-container *ngIf="preview as p">
    <section class="card" aria-label="מוצר">
      <h2>מוצר</h2>
      <div class="product-hero" *ngIf="p.hasImage">
        <div
          class="product-photo-wrap"
          data-testid="classification-product-image-wrap"
          tabindex="0"
          (focus)="openImagePopup()"
          (blur)="scheduleCloseImagePopup()"
        >
          <img
            class="product-photo"
            data-testid="classification-product-image"
            [src]="productImageUrl(p.productId)"
            [alt]="p.displayName"
            (mouseenter)="openImagePopup()"
            (mouseleave)="scheduleCloseImagePopup()"
          />
          <div
            class="product-photo-popup"
            *ngIf="imagePopupOpen"
            data-testid="classification-product-image-popup"
            role="dialog"
            aria-label="תמונת מוצר מוגדלת"
          >
            <button
              type="button"
              class="product-photo-close"
              data-testid="classification-product-image-close"
              aria-label="סגור תמונה"
              (mouseenter)="cancelCloseImagePopup()"
              (mouseleave)="scheduleCloseImagePopup()"
              (click)="closeImagePopup($event)"
            >
              ×
            </button>
            <img
              class="product-photo-popup-img"
              [src]="productImageUrl(p.productId)"
              alt=""
            />
          </div>
        </div>
        <p class="image-credit muted">{{ imageCredit(p.imageSource) }} · העבירו עכבר להגדלה</p>
      </div>
      <p class="product-name" dir="auto" data-testid="classification-product-name">{{ p.displayName }}</p>
      <p class="muted" dir="auto" data-testid="classification-product-brand">
        מותג: {{ p.brandName || '—' }}
      </p>
      <p class="muted" dir="auto" data-testid="classification-product-qty">
        כמות: {{ p.qtyLabel || '—' }}
      </p>
      <p class="muted" data-testid="classification-name-source">
        מקור השם: {{ displayNameSourceLabel(p.displayNameSource) }}
      </p>
      <p class="muted" dir="auto">שם גולמי: {{ p.nameRaw }}</p>
      <p class="muted">ברקוד: {{ p.barcode || '—' }} · מזהה: {{ p.productId }}</p>
      <p class="muted" *ngIf="!p.hasEmbedding">אין הטמעה למוצר — מרכזים ושכן מאומת לא ירוצו.</p>

      <div
        class="verified"
        *ngIf="p.verifiedCategorySlug || p.verifiedTypeSlug"
        data-testid="classification-verified-banner"
      >
        <strong>{{ classificationSourceLabel(p.source, p.model) }}:</strong>
        {{ categoryName(p.verifiedCategorySlug) }} /
        {{ typeName(p.verifiedTypeSlug) }}
        <span class="muted" *ngIf="p.graphVersion"> · {{ p.graphVersion }}</span>
        <span class="muted" *ngIf="p.verifiedAt">
          ({{ p.verifiedAt | date:'short' }}{{ p.verifiedBy ? ', ' + p.verifiedBy : '' }})
        </span>
      </div>
      <p class="muted" *ngIf="!p.verifiedCategorySlug">עדיין לא מאומת.</p>
      <p *ngIf="p.attributes?.length">
        מאפיינים:
        <span *ngFor="let attr of p.attributes">
          {{ attr.attributeSlug }}={{ attr.valueSlug || attr.valueText }}
        </span>
      </p>
      <div class="actions">
        <p class="muted model-ensemble-hint" *ngIf="usableClassifyModels.length > 0">
          שמירה כששתיים מסכימות:
          {{ ensembleModelLabels }}
        </p>
        <p class="muted" *ngIf="usableClassifyModels.length === 0">
          אין מודלים זמינים — בדקו מפתחות API.
        </p>
        <button
          type="button"
          (click)="runGraph()"
          [disabled]="runningGraph || usableClassifyModels.length === 0"
        >
          {{ runningGraph ? 'מריץ 3 מודלים…' : 'הרץ סיווג (3 מודלים)' }}
        </button>
      </div>
      <section class="graph-trace" *ngIf="p.graphRun as run">
        <div class="graph-trace-head">
          <h3>החלטות המודלים</h3>
          <span class="outcome-pill" [attr.data-outcome]="run.outcome">{{ outcomeLabel(run.outcome) }}</span>
        </div>
        <p class="graph-meta muted">
          <span>{{ run.model }}</span>
          <span>{{ run.graphVersion }}</span>
          <span>{{ run.tokensIn }} in / {{ run.tokensOut }} out</span>
          <span>{{ formatUsd(run.costUsd) }}</span>
        </p>
        <div class="model-votes" *ngIf="run.votes?.length">
          <h4>המלצות מודלים</h4>
          <table>
            <thead>
              <tr>
                <th>מודל</th>
                <th>קבוצה</th>
                <th>תת-קבוצה</th>
                <th>הסבר</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let vote of run.votes">
                <td>{{ modelLabel(vote.model) }}</td>
                <td>
                  <span *ngIf="vote.error">{{ vote.error }}</span>
                  <span *ngIf="!vote.error">
                    {{ categoryName(vote.categorySlug) || vote.categoryDecision || '—' }}
                  </span>
                </td>
                <td>{{ vote.error ? '—' : (typeName(vote.typeSlug) || vote.typeDecision || '—') }}</td>
                <td class="vote-why">{{ vote.why || '' }}</td>
                <td>
                  <button
                    type="button"
                    *ngIf="!vote.error && vote.categorySlug && vote.typeSlug"
                    (click)="applyModelVote(vote)"
                  >
                    בחר
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ol class="graph-steps">
          <li class="graph-step" *ngFor="let step of run.steps; let i = index" [attr.data-decision]="step.decision">
            <div class="graph-step-index" aria-hidden="true">{{ i + 1 }}</div>
            <div class="graph-step-body">
              <div class="graph-step-top">
                <strong class="graph-step-title">{{ stepTitle(step.name) }}</strong>
                <span class="decision-pill" [attr.data-decision]="step.decision">{{ stepDecisionLabel(step) }}</span>
              </div>
              <p class="graph-step-why" *ngIf="step.why">{{ step.why }}</p>
              <p class="graph-step-evidence muted" *ngIf="step.evidence">{{ step.evidence }}</p>
              <div class="graph-step-foot">
                <span class="muted" *ngIf="step.tokensIn || step.tokensOut">
                  {{ step.tokensIn }}/{{ step.tokensOut }} · {{ formatUsd(step.costUsd) }}
                </span>
                <button
                  type="button"
                  class="linkish"
                  *ngIf="hasGraphStepIo(step)"
                  data-testid="classification-graph-step-io"
                  (click)="openGraphStepIo(step)"
                >
                  קלט/פלט
                </button>
              </div>
            </div>
          </li>
        </ol>
      </section>
    </section>

    <section class="card" aria-label="הצעות">
      <h2>הצעות לפי שיטה</h2>
      <p class="muted" *ngIf="p.observations.length === 0">אין הצעות — אין הטמעה, או שאין מוצרים מסווגים בעץ.</p>
      <div class="table-wrap" *ngIf="p.observations.length">
        <table>
          <thead>
            <tr>
              <th>שיטה</th>
              <th>קבוצה</th>
              <th>תת-קבוצה</th>
              <th>ביטחון</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let o of p.observations"
              [class.chosen]="selectedObservationMethod === o.method"
              [attr.data-testid]="'classification-obs-' + o.method"
            >
              <td>{{ methodLabel(o.method) }}</td>
              <td>{{ categoryName(o.categorySlug) }}</td>
              <td>{{ typeName(o.typeSlug) }}</td>
              <td>{{ o.confidence | number:'1.0-2' }}</td>
              <td class="row-actions">
                <button
                  type="button"
                  class="linkish"
                  [attr.data-testid]="'classification-obs-io-' + o.method"
                  (click)="openObservationIo(o)"
                >
                  קלט/פלט
                </button>
                <button type="button" class="linkish" (click)="applyObservation(o)">
                  בחר
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <div
      class="io-popup"
      *ngIf="ioPopup as io"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="'קלט ופלט של ' + io.title"
      data-testid="classification-io-popup"
    >
      <button
        type="button"
        class="io-popup-backdrop"
        aria-label="סגור"
        (click)="closeIoPopup()"
      ></button>
      <div class="io-popup-card">
        <button
          type="button"
          class="io-popup-close"
          data-testid="classification-io-close"
          aria-label="סגור"
          (click)="closeIoPopup()"
        >
          ×
        </button>
        <h3>{{ io.title }}</h3>
        <p class="io-subtitle" *ngIf="io.subtitle">{{ io.subtitle }}</p>
        <p class="io-kicker">קלט</p>
        <pre class="io-block" dir="auto">{{ io.input }}</pre>
        <p class="io-kicker">פלט</p>
        <pre class="io-block" dir="auto">{{ io.output }}</pre>
      </div>
    </div>

    <section class="card" aria-label="אימות">
      <h2>אימות / שינוי</h2>
      <div class="form-grid">
        <label>
          מחלקה
          <select
            data-testid="classification-department"
            [(ngModel)]="selectedDepartmentSlug"
            (ngModelChange)="onDepartmentChange()"
          >
            <option value="">— הכל —</option>
            <option *ngFor="let d of departments" [value]="d.slug">{{ d.nameHe }}</option>
          </select>
        </label>
        <label>
          קבוצה
          <select
            data-testid="classification-category"
            [(ngModel)]="selectedCategorySlug"
            (ngModelChange)="onCategoryChange()"
          >
            <option value="">— בחרו —</option>
            <option *ngFor="let c of groupsForDepartment" [value]="c.slug">{{ c.nameHe }}</option>
          </select>
        </label>
        <label>
          תת-קבוצה
          <select
            data-testid="classification-type"
            [(ngModel)]="selectedTypeSlug"
            (ngModelChange)="onTypeChange()"
          >
            <option value="">— בחרו —</option>
            <option *ngFor="let t of typesForCategory" [value]="t.slug">{{ t.nameHe }}</option>
          </select>
        </label>
        <label>
          מי מאמת (אופציונלי)
          <input type="text" [(ngModel)]="verifiedBy" placeholder="oren" />
        </label>
      </div>

      <div class="actions">
        <button
          type="button"
          data-testid="classification-verify"
          (click)="verify()"
          [disabled]="verifying || !selectedCategorySlug || !selectedTypeSlug"
        >
          אמת קבוצה ותת-קבוצה
        </button>
        <button
          type="button"
          class="secondary"
          data-testid="classification-clear"
          (click)="clearClassification()"
          [disabled]="clearing || (!p.verifiedCategorySlug && !p.verifiedTypeSlug)"
        >
          נקה סיווג
        </button>
      </div>

      <div class="new-type">
        <h3>תת-קבוצה חדשה תחת הקבוצה הנבחרת</h3>
        <div class="lookup-row">
          <input type="text" [(ngModel)]="newTypeNameHe" placeholder="שם בעברית" />
          <button
            type="button"
            class="secondary"
            (click)="createType()"
            [disabled]="creatingType || !selectedCategorySlug"
          >
            הוסף תת-קבוצה
          </button>
          <button
            type="button"
            class="secondary"
            (click)="hideSelectedNode('group')"
            [disabled]="hidingNode || !selectedCategorySlug"
          >
            הסתר קבוצה
          </button>
          <button
            type="button"
            class="secondary"
            (click)="hideSelectedNode('sub_group')"
            [disabled]="hidingNode || !selectedTypeSlug"
          >
            הסתר תת-קבוצה
          </button>
        </div>
      </div>
    </section>
  </ng-container>
</div>
